<script lang="ts">
	import { getClient, mutate } from 'svelte-apollo';
	import { gql } from 'apollo-boost';
	import queryString from 'query-string';
	import { Link } from 'svelte-routing';
	import { userManager } from '../../stores';
	import { mutationAuthUser } from '../../graphql/queries/users';
	import LoginScreenBox from '../../components/Users/LoginScreenBox.svelte';
	import Button from '../../components/Button.svelte';
	import GraphErrorList from '../../components/GraphQL/GraphErrorList.svelte';

	const allAuthProviders = ['google', 'azure'];

	const client = getClient();

	const AUTH_MUTATION = gql(mutationAuthUser);

	let isLoading = false;
	let error = false;
	let errorList: any;
	export let authProvider: string;

	if (typeof window !== 'undefined') {
		const { code } = queryString.parse(window.location.search);

		if (code && allAuthProviders.includes(authProvider)) {
			authFetch(code);
		} else {
			error = true;
		}
	}

	function authFetch(code: string | string[]) {
		isLoading = true;
		mutate(client, {
			mutation: AUTH_MUTATION,
			variables: {
				code,
				authProvider
			},
			errorPolicy: 'all'
		})
			.then(({ errors: resErrors, data }) => {
				if (resErrors) {
					errorList = resErrors;
				} else {
					errorList = null;
					// console.log(data.authorizeUser);

					userManager.logIn(data.authorizeUser);
				}
			})
			.catch((e) => {
				console.error('error: ', e);
			})
			.finally(() => {
				isLoading = false;
			});
	}
</script>

<LoginScreenBox>
	{#if error}
		<div>
			Incorrect link. Go back to
			<Link to="/">
				<Button variant="raised">Login</Button>
			</Link>
		</div>
	{/if}

	{#if isLoading}
		<p>Checking application access</p>
		<p>
			You should be redirected in few moments. If not please
			<Link to="/">click here</Link>
		</p>
	{/if}

	<GraphErrorList {errorList}>
		<div>If you repeatedly cannot log in and you believe this is a mistake</div>
		<div>please contact us on info@adpicker.com</div>
		<br />
		<br />
		<p>Go back to</p>
		<Link href="/">
			<Button margin variant="raised">Login screen</Button>
		</Link>
	</GraphErrorList>
</LoginScreenBox>
